import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "keypadButton", "backspaceButton", "clearButton"];
  connect() {
    this.inputTarget.value = "";
    console.log("Keypad controller connected");
  }

  appendNumber({ params }) {
    const { value } = params;
    this.inputTarget.value += value;
    this.inputTarget.focus();
  }

  appendPlus(e) {
    if (e.params.value == "0") {
      e.preventDefault();
      e.stopPropagation();
      this.inputTarget.value += "+";
      this.inputTarget.focus();
    }
  }

  backspace() {
    this.inputTarget.value = this.inputTarget.value.slice(0, -1);
  }

  clear() {
    this.inputTarget.value = "";
  }

  validate({ data }) {
    if (isNaN(data) && !["#", "*", "+"].includes(data)) {
      this.inputTarget.value = this.inputTarget.value.slice(0, -1);
      this.inputTarget.focus();
    }
  }

  dial() {
    this.dispatch("dial", {
      detail: { value: this.inputTarget.value },
    });
  }
}
